<template>
	<crop-map :initial-center="latLng" :should-fit-bounds="false">
		<search-map-marker
			v-for="(result, idx) in offers"
			:key="'MARKER_' + idx + '_' + result.match_id"
			:active-id="activeId"
			:item="result"
			:user="user"
		/>
		<l-marker :lat-lng="latLng" key="HOME_ICON">
			<l-icon :icon-anchor="staticAnchor">
				<!-- v-bind:popup-anchor="[-10,-60]" -->
				<div
					class="w-12 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-6100"
				>
					<svg
						class="w-full"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 39 59.7"
						:fill="mapMeta.activeOffersCount > 1 ? '#96bd0d' : '#F10048'"
					>
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1">
								<path
									class="cls-1"
									d="M19.5,0C30.2,0,39,9.3,39,20.9a33.2,33.2,0,0,1-3.1,12.7,82.3,82.3,0,0,1-6.8,12.8c-2.5,4-5,7.4-6.9,9.9L20,59.1l-.5.6-.5-.6-2.2-2.8c-1.9-2.5-4.4-5.9-6.9-9.9A82.3,82.3,0,0,1,3.1,33.6,33.2,33.2,0,0,1,0,20.9C0,9.3,8.8,0,19.5,0Z"
								/>
							</g>
						</g>
					</svg>
					<div
						class="p-1 absolute top-0 left-1/2 transform -translate-x-1/2 text-white text-center text-base font-sans"
						v-on:click="$inertia.visit($route('offer_all.index'))"
					>
						<ui-icon class="h-8 w-8" :name="centerIconName" stroke-width="2" />
						<div
							class="font-semibold text-xl leading-3"
							v-if="accountStage == 'ACTIVE'"
						>
							{{ mapMeta.activeOffersCount }}
						</div>
					</div>
				</div>
			</l-icon>
			<l-popup ref="popup" class="font-sans text-base p-6">
				<ui-button
					type="primary"
					class="text-sm"
					v-on:click="$inertia.visit($route('offer_all.index'))"
					label="Go to my lots"
				/>
			</l-popup>
		</l-marker>

		<template v-slot:other>
			<l-circle
				:lat-lng="latLng"
				:radius="150 * 1000"
				color="#F10048"
				:weight="0"
				:fill-opacity="0.2"
				fill-color="#F10048"
				v-if="accountStage != 'ACTIVE'"
			/>
		</template>
	</crop-map>
</template>

<script>
import { LMarker, LPopup, LIcon, LCircle } from "vue2-leaflet";

export default {
	props: {
		offers: {
			type: Array,
			required: true,
		},
		center: {
			type: Object,
			default: null,
		},
	},
	components: {
		LIcon,
		LMarker,
		LPopup,
		LCircle,
	},
	data() {
		return {
			staticAnchor: [6, 37],
			mapMeta: this.$inertia.page.props.mapMeta,
			user: this.$inertia.page.props.user,
			activeId: null,
		};
	},
	mounted() {
		let that = this;
		this.$root.$on("new-active-marker-id", function (newId) {
			console.log("NEW ACTIVE MARKER ID", newId);
			that.activeId = newId;
		});
	},
	computed: {
		latLng() {
			// center kommt aus dem StartController (nach require.location, sieht die
			// frische Haupt-Location); Fallback auf den global vorab evaluierten
			// mapMeta.center.
			let c = (this.center ?? this.mapMeta.center).coordinates;
			return [c[1], c[0]];
		},
		accountStage() {
			if (!this.user.address.zip) {
				return "COMPLETE_PROFILE";
			} else if (this.user.status == "REGISTERED") {
				return "PENDING_ACTIVATION";
			} else {
				return "ACTIVE";
			}
		},
		centerIconName() {
			if (this.accountStage == "ACTIVE") {
				return "barn";
			} else {
				return "help-circle";
			}
		},
	},
};
</script>
